export default {
      id: "i-arrow-accordion1-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-accordion1",
      toString: function () {
        return this.url;
      }
    }